/** ESA converse / conversation BFF paths. Values recovered from git HEAD per DR-1. */

export const ESA_API_PATHS = {
  CONVERSE: '/converse',
  CONVERSATIONS: '/conversations',
  converseStream(sessionId: string): string {
    return `/converse/stream?session_id=${encodeURIComponent(sessionId)}`;
  },
  conversation(conversationId: string): string {
    return `/conversations/${encodeURIComponent(conversationId)}`;
  },
  /** Dedicated turn-status SSE (feat-80); not notification stream. */
  conversationStatusStream(conversationId: string, afterSeq?: number): string {
    const base = `/conversations/${encodeURIComponent(conversationId)}/status/stream`;
    if (afterSeq != null && Number.isFinite(afterSeq)) {
      return `${base}?after_seq=${encodeURIComponent(String(afterSeq))}`;
    }
    return base;
  },
} as const;

/** Agentic-ops HIL paths. */
export const AGOPS_API_PATHS = {
  HIL_SEARCH: '/services/ops/hil-requests/search',
  hilById(hilId: string): string {
    return `/services/ops/hil-requests/${encodeURIComponent(hilId)}`;
  },
} as const;

/** File storage service paths. */
export const FSS_API_PATHS = {
  UPLOAD_FILE: '/services/files/upload/file',
  UPLOAD_BULK: '/services/files/upload/bulk',
  uploadJob(jobId: string): string {
    return `/services/files/upload/jobs/${jobId}`;
  },
  storedFile(ukey: string): string {
    return `/services/files/stored-files/${ukey}`;
  },
  storedFileDownload(ukey: string): string {
    return `/services/files/stored-files/${encodeURIComponent(ukey)}/download`;
  },
} as const;

export const PKS_API_PATHS = {
  PRODUCT_LINES: '/api/pks/v1/product-lines',
} as const;

export const EXPERIENCE_API_PATHS = {
  PERMISSIONS: '/experience/permissions',
  PERSONALIZATION: '/experience/personalization',
} as const;

/** Bootstrap paths (config-driven via hydration.type === 'bootstrap'). */
export const TC_API_PATHS = {
  BOOTSTRAP: '/app/bootstrap',
  bootstrap(surface: string): string {
    return `${this.BOOTSTRAP}?surface=${encodeURIComponent(surface)}`;
  },
} as const;

export const AUTH_REFRESH_TOKEN_PATH = '/auth/refresh-token';

export const ESA_NOTIFICATION_STREAM_PATH = '/notifications/stream';
